import { jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { PaymentMethodCode } from '@web/shared/module/shop';
import { AdminShippingMethodContextOperationsResponse } from './admin-shipping-method-context-operations.response';
import { MultimediaResponse } from '@web/shared/module/multimedia';

@jsonObject
export class AdminPaymentMethodDetailsResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly code!: PaymentMethodCode;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(Boolean)
  public readonly isActive!: boolean;

  @jsonMember(String)
  public readonly description!: string;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(MultimediaResponse)
  public readonly previewFile?: Nillable<MultimediaResponse>;

  @jsonMember(AdminShippingMethodContextOperationsResponse)
  public readonly contextOperations!: AdminShippingMethodContextOperationsResponse;
}
